<template>
	<div class="seller-stock">
		<div class="btnbox">
			<el-button size="small" @click="goList">云仓列表</el-button>
			<el-button size="small" @click="goExit">取回记录</el-button>
			<el-button size="small" @click="goSettle">结算中心</el-button>
		</div>
		<div class="tablebox">
			<div class="filterdiv filterty" ref="filter">
				<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="small" label-width="0"
					v-if="filtershow">
					<el-form-item>
						<el-select v-model="formfilter.warehouse_id" placeholder="全部云仓" filterable clearable>
							<el-option label="全部云仓" value=""></el-option>
							<el-option :label="v.name" :value="v.id" v-for="v in warehouses" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-input v-model="formfilter.style_number" placeholder="款号" clearable
							@keyup.enter.native="onfilter"></el-input>
					</el-form-item>
					<el-form-item>
						<el-checkbox v-model="formfilter.only_stock" @change="onfilter">仅看有库存</el-checkbox>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onfilter">查询</el-button>
						<el-button @click="onreset">重置</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="warning" :disabled="!selected.length" @click="openExit">申请取回{{
							selected.length ? '（已选 ' + selected.length + '）' : '' }}</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="zk" @click="filtershow = !filtershow">
				<span>{{ filtershow ? '收起' : '展开' }}</span>
			</div>
			<div class="tablediv" ref="tablediv">
				<el-table :data="list" style="width: 100%" border height="100%" @selection-change="onSelect">
					<el-table-column type="selection" width="46" align="center" :selectable="canSelect"></el-table-column>
					<el-table-column label="云仓" align="center" header-align="center" min-width="110px">
						<template slot-scope="scope">{{ warehouseName(scope.row.warehouse_id) }}</template>
					</el-table-column>
					<el-table-column prop="style_number" label="款号" align="center" header-align="center" min-width="120px"></el-table-column>
					<el-table-column prop="size" label="尺码" align="center" header-align="center" width="70px"></el-table-column>
					<el-table-column label="可用" align="center" header-align="center" width="70px">
						<template slot-scope="scope">{{ available(scope.row) }}</template>
					</el-table-column>
					<el-table-column label="状态" align="center" header-align="center" width="80px">
						<template slot-scope="scope">
							<span v-if="scope.row.buyout_state == 1" class="buyout-tag">已变现</span>
							<span v-else>--</span>
						</template>
					</el-table-column>
					<el-table-column label="供货折扣" align="center" header-align="center" width="90px">
						<template slot-scope="scope">{{ formatEntryDiscount(scope.row.discount) }}折</template>
					</el-table-column>
					<el-table-column label="供货价" align="center" header-align="center" width="90px">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.unit_cost) }}</template>
					</el-table-column>
					<el-table-column label="建议零售价" align="center" header-align="center" width="100px">
						<template slot-scope="scope">¥{{ fenToYuan(scope.row.retail_price) }}</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="入仓时间" align="center" header-align="center" width="160px"></el-table-column>
					<el-table-column label="操作" fixed="right" align="center" header-align="center" width="150px">
						<template slot-scope="scope">
							<div class="operation_i">
								<span @click="openDiscount(scope.row)">调低折扣</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="pagediv">
				<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
					:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
					@current-change="handleCurrentChange" @size-change="handleSizeChange">
				</el-pagination>
			</div>
		</div>

		<el-dialog title="调低折扣" :visible.sync="discountShow" width="460px" :before-close="closeDiscount">
			<div class="forms" v-if="discountShow">
				<el-form label-width="110px">
					<el-form-item label="款号尺码">
						<div>{{ currentStock.style_number }} {{ currentStock.size }}</div>
					</el-form-item>
					<el-form-item label="当前折扣">
						<div>{{ formatEntryDiscount(currentStock.discount) }} 折</div>
					</el-form-item>
					<el-form-item label="新折扣">
						<el-input v-model="discountForm.discount" placeholder="须低于当前折扣，如 4.5">
							<template slot="append">折</template>
						</el-input>
					</el-form-item>
					<div class="form-tip">供货价 = 吊牌价 × 新折扣 ÷ 10。只降不升，已售部分不追溯。释放的是入仓冻结，不进卖家余额。</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeDiscount">取消</el-button>
				<el-button type="primary" :loading="discountSaving" @click="onSaveDiscount">确定</el-button>
			</div>
		</el-dialog>

		<el-dialog title="申请取回" :visible.sync="exitShow" width="640px" :before-close="closeExit">
			<div class="forms" v-if="exitShow">
				<el-form label-width="110px">
					<el-form-item label="取回明细">
						<el-table :data="exitItems" border size="mini" style="width: 100%" max-height="220">
							<el-table-column prop="style_number" label="款号" min-width="110"></el-table-column>
							<el-table-column prop="size" label="尺码" width="70" align="center"></el-table-column>
							<el-table-column label="可取回" width="70" align="center">
								<template slot-scope="scope">{{ scope.row.available }}</template>
							</el-table-column>
							<el-table-column label="数量" width="110" align="center">
								<template slot-scope="scope">
									<el-input-number v-model="scope.row.quantity" :min="1" :max="scope.row.available"
										:precision="0" :controls="false" size="mini"></el-input-number>
								</template>
							</el-table-column>
						</el-table>
					</el-form-item>
					<el-form-item label="取回原因">
						<el-select v-model="exitForm.reason" placeholder="请选择">
							<el-option :label="v.name" :value="v.id" v-for="v in reasonList" :key="v.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="收货地址">
						<el-select v-model="exitForm.address_id" placeholder="从地址簿选择" clearable filterable @change="onPickAddress">
							<el-option v-for="v in addresses" :key="v.id" :label="addressLabel(v)" :value="v.id"></el-option>
						</el-select>
						<el-button type="text" @click="goAddress">管理地址</el-button>
					</el-form-item>
					<el-form-item label="收货人">
						<el-input v-model="exitForm.receiver_name" placeholder="请输入收货人"></el-input>
					</el-form-item>
					<el-form-item label="收货电话">
						<el-input v-model="exitForm.receiver_mobile" placeholder="请输入收货电话"></el-input>
					</el-form-item>
					<el-form-item label="收货地址">
						<el-input type="textarea" :rows="2" v-model="exitForm.receiver_address" placeholder="请输入收货地址"></el-input>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="closeExit">取消</el-button>
				<el-button type="primary" :loading="exitSaving" @click="onSaveExit">确定</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { fenToYuan, apiMsg, formatEntryDiscount, stockDiscountZhe } from './money.js'

	export default {
		name: 'SellerWarehouseStock',
		data() {
			return {
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,
				filtershow: true,
				formfilter: {
					warehouse_id: '',
					style_number: '',
					only_stock: true
				},
				stockSource: [],
				warehouses: [],
				selected: [],
				discountShow: false,
				discountSaving: false,
				currentStock: {},
				discountForm: {
					discount: ''
				},
				exitShow: false,
				exitSaving: false,
				exitItems: [],
				exitForm: {
					reason: '',
					address_id: '',
					receiver_name: '',
					receiver_mobile: '',
					receiver_address: '',
					warehouse_id: ''
				},
				addresses: [],
				reasonList: [
					{ id: 1, name: '长时间无销售' },
					{ id: 2, name: '其他渠道已售' },
					{ id: 3, name: '换仓' },
					{ id: 4, name: '其他' }
				]
			}
		},
		mounted() {
			this.loadWarehouses()
			this.onlist()
			this.resizeObserver = new ResizeObserver(entries => {
				for (let entry of entries) {
					const cr = entry.contentRect
					if (this.$refs.tablediv) {
						this.$refs.tablediv.style.height = 'calc(100% - ' + (Number(cr.height) + 30) + 'px)'
					}
				}
			})
			if (this.$refs.filter) {
				this.resizeObserver.observe(this.$refs.filter)
			}
		},
		beforeDestroy() {
			if (this.resizeObserver) {
				this.resizeObserver.disconnect()
			}
		},
		methods: {
			fenToYuan: fenToYuan,
			formatEntryDiscount: formatEntryDiscount,
			available(row) {
				return Math.max(0, Number(row.quantity || 0) - Number(row.sold_quantity || 0))
			},
			canSelect(row) {
				return this.available(row) > 0
			},
			addressLabel(row) {
				var mark = row.is_default == 1 ? '（默认）' : ''
				return row.name + ' ' + row.phone + mark + ' ' + row.address
			},
			goAddress() {
				this.$router.push('/seller/warehouse/address')
			},
			loadAddresses() {
				this.$axios.post('api/cloud_warehouse/address_list', {}).then(res => {
					if (res.data.code === 0) {
						this.addresses = (res.data.data && res.data.data.list) || []
						var def = this.addresses.filter(function(item) {
							return Number(item.is_default) === 1
						})[0]
						if (def && !this.exitForm.address_id) {
							this.exitForm.address_id = def.id
							this.onPickAddress(def.id)
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			onPickAddress(id) {
				var row = this.addresses.find(function(item) {
					return Number(item.id) === Number(id)
				})
				if (!row) {
					return
				}
				this.exitForm.receiver_name = row.name
				this.exitForm.receiver_mobile = row.phone
				this.exitForm.receiver_address = row.address
			},
			warehouseName(id) {
				var row = this.warehouses.find(function(item) {
					return Number(item.id) === Number(id)
				})
				return row ? row.name : (id || '--')
			},
			goList() {
				this.$router.push('/seller/warehouse/index')
			},
			goExit() {
				this.$router.push('/seller/warehouse/exit')
			},
			goSettle() {
				this.$router.push('/seller/warehouse/settle')
			},
			onSelect(rows) {
				this.selected = rows || []
			},
			onfilter() {
				this.page = 1
				this.onlist()
			},
			onreset() {
				this.formfilter = {
					warehouse_id: '',
					style_number: '',
					only_stock: true
				}
				this.page = 1
				this.onlist()
			},
			handleCurrentChange() {
				if (this.formfilter.only_stock && this.stockSource.length) {
					this.applyStockPage()
					return
				}
				this.onlist()
			},
			handleSizeChange(val) {
				this.page = 1
				this.pageSize = val
				if (this.formfilter.only_stock && this.stockSource.length) {
					this.applyStockPage()
					return
				}
				this.onlist()
			},
			loadWarehouses() {
				this.$axios.get('api/cloud_warehouse/warehouse_list', {
					params: { page: 1, limit: 100 }
				}).then(res => {
					if (res.data.code === 0) {
						this.warehouses = (res.data.data && res.data.data.list) || []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			stockQuery() {
				var params = { role: 'seller' }
				if (this.formfilter.warehouse_id !== '' && this.formfilter.warehouse_id !== null) {
					params.warehouse_id = this.formfilter.warehouse_id
				}
				if (this.formfilter.style_number) {
					params.style_number = this.formfilter.style_number
				}
				return params
			},
			applyStockPage() {
				var start = (this.page - 1) * this.pageSize
				this.total = this.stockSource.length
				this.list = this.stockSource.slice(start, start + this.pageSize)
				if (this.page > 1 && !this.list.length) {
					this.page = 1
					this.list = this.stockSource.slice(0, this.pageSize)
				}
			},
			loadInStock(apiPage, acc) {
				var params = this.stockQuery()
				params.page = apiPage
				params.limit = 100
				this.$axios.get('api/cloud_warehouse/stock_list', { params: params }).then(res => {
					if (res.data.code !== 0) {
						this.$message.error(apiMsg(res))
						return
					}
					var data = res.data.data || {}
					var rows = data.list || []
					var next = acc.concat(rows)
					var count = data.count || 0
					if (rows.length && next.length < count && apiPage < 30) {
						this.loadInStock(apiPage + 1, next)
						return
					}
					this.stockSource = next.filter((row) => {
						return this.available(row) > 0
					})
					this.applyStockPage()
				}).catch(err => {
					console.log(err)
				})
			},
			onlist() {
				this.stockSource = []
				if (this.formfilter.only_stock) {
					this.loadInStock(1, [])
					return
				}
				var params = this.stockQuery()
				params.page = this.page
				params.limit = this.pageSize
				this.$axios.get('api/cloud_warehouse/stock_list', { params: params }).then(res => {
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.list = data.list || []
						this.total = data.count || 0
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					console.log(err)
				})
			},
			openDiscount(row) {
				this.currentStock = row || {}
				this.discountForm.discount = ''
				this.discountShow = true
			},
			closeDiscount() {
				this.discountShow = false
				this.currentStock = {}
			},
			onSaveDiscount() {
				var current = stockDiscountZhe(this.currentStock.discount)
				var num = parseFloat(this.discountForm.discount)
				if (this.discountForm.discount === '' || isNaN(num) || num <= 0 || num > 10) {
					this.$message.warning('请输入 0~10 的折扣（如 5 表示 5 折），且须大于 0')
					return
				}
				if (isNaN(current) || num >= current) {
					this.$message.warning('新折扣须低于当前折扣（当前为' + this.formatEntryDiscount(this.currentStock.discount) + '折）')
					return
				}
				this.discountSaving = true
				this.$axios.post('api/cloud_warehouse/adjust_discount', {
					stock_id: this.currentStock.id,
					discount: num
				}).then(res => {
					this.discountSaving = false
					if (res.data.code === 0) {
						var data = res.data.data || {}
						this.$message.success('已释放保证金冻结 ¥' + this.fenToYuan(data.release_amount))
						this.closeDiscount()
						this.onlist()
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.discountSaving = false
					console.log(err)
				})
			},
			openExit() {
				if (!this.selected.length) {
					this.$message.warning('请先勾选要取回的库存')
					return
				}
				var warehouseId = this.selected[0].warehouse_id
				var mixed = this.selected.some(function(row) {
					return Number(row.warehouse_id) !== Number(warehouseId)
				})
				if (mixed) {
					this.$message.warning('请选择同一云仓的库存后再申请取回')
					return
				}
				if (this.selected.length > 50) {
					this.$message.warning('单次最多提交50条明细')
					return
				}
				this.exitItems = this.selected.map(function(row) {
					var avail = Math.max(0, Number(row.quantity || 0) - Number(row.sold_quantity || 0))
					return {
						stock_id: row.id,
						style_number: row.style_number,
						size: row.size,
						available: avail,
						quantity: avail
					}
				}).filter(function(item) {
					return item.available > 0
				})
				if (!this.exitItems.length) {
					this.$message.warning('所选库存暂无可取回数量')
					return
				}
				this.exitForm = {
					reason: '',
					address_id: '',
					receiver_name: '',
					receiver_mobile: '',
					receiver_address: '',
					warehouse_id: warehouseId
				}
				this.exitShow = true
				this.loadAddresses()
			},
			closeExit() {
				this.exitShow = false
				this.exitItems = []
			},
			onSaveExit() {
				if (!this.exitForm.reason) {
					this.$message.warning('请选择取回原因')
					return
				}
				if (!String(this.exitForm.receiver_name || '').trim()) {
					this.$message.warning('请输入收货人')
					return
				}
				if (!String(this.exitForm.receiver_mobile || '').trim()) {
					this.$message.warning('请输入收货电话')
					return
				}
				if (!String(this.exitForm.receiver_address || '').trim()) {
					this.$message.warning('请输入收货地址')
					return
				}
				var items = []
				for (var i = 0; i < this.exitItems.length; i++) {
					var row = this.exitItems[i]
					var qty = Number(row.quantity || 0)
					if (qty <= 0) {
						this.$message.warning('取回数量必须大于0')
						return
					}
					if (qty > row.available) {
						this.$message.warning('在仓不足（款号：' + row.style_number + '，尺码：' + row.size + '，可取回：' + row.available + '）')
						return
					}
					items.push({
						stock_id: row.stock_id,
						quantity: qty
					})
				}
				this.exitSaving = true
				var payload = {
					warehouse_id: this.exitForm.warehouse_id,
					reason: this.exitForm.reason,
					receiver_name: this.exitForm.receiver_name,
					receiver_mobile: this.exitForm.receiver_mobile,
					receiver_address: this.exitForm.receiver_address,
					items: JSON.stringify(items)
				}
				if (this.exitForm.address_id) {
					payload.address_id = this.exitForm.address_id
				}
				this.$axios.post('api/cloud_warehouse/exit_apply', payload).then(res => {
					this.exitSaving = false
					if (res.data.code === 0) {
						var applyNo = (res.data.data && res.data.data.apply_no) || ''
						this.$message.success(applyNo ? '取回申请已提交（' + applyNo + '）' : '取回申请已提交')
						this.closeExit()
						this.onlist()
						this.$router.push({
							path: '/seller/warehouse/exit',
							query: applyNo ? { apply_no: applyNo } : {}
						})
					} else {
						this.$message.error(apiMsg(res))
					}
				}).catch(err => {
					this.exitSaving = false
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.seller-stock {
		height: 100%;
	}

	.tablebox {
		height: calc(100% - 72px);
	}

	.form-tip {
		color: #909399;
		font-size: 12px;
		line-height: 20px;
		margin-top: 10px;
	}

	.buyout-tag {
		color: #67C23A;
	}

	/deep/ .el-input-number {
		width: 72px;
	}

	/deep/ .el-input-number .el-input__inner {
		padding: 0 4px;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/components/seller/warehouse/stock.vue